module.exports = __webpack_public_path__ + "static/media/img-exhibition-guide02.6c06742a.jpg";